import React, { useMemo } from 'react';
import classes from './button_v2_section.module.scss';
import { getCurrentLocalization } from '../../../../config/i18n';

function ButtonV2Section({
  title = '',
  iconUrl = '',
  iconUrlV2 = '',
  action = {}
}) {
  const iconSrc = iconUrlV2 || iconUrl;

  const hrefWithLang = useMemo(() => {
    if (!action.webUrl) return '';
    const url = new URL(action.webUrl, window.location.origin);
    url.searchParams.set('lng', getCurrentLocalization());
    return url.href;
  }, [action.webUrl]);

  return (
    <div className={ classes.sectionContainer }>
      <a
        className={ classes.buttonV2Container }
        data-testid="HP-button-v2-section"
        role="button"
        tabIndex={ 0 }
        href={ hrefWithLang }
      >
        {iconSrc && (
        <div className={ classes.iconContainer }>
          <img src={ iconSrc } className={ classes.icon } alt="" />
        </div>
        )}
        <div className={ classes.titleContainer }>
          <span className={ classes.title }>{ title }</span>
        </div>
      </a>
    </div>
  );
}

export default ButtonV2Section;
